/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosEnumLinkIcons, GeminiLinkFragment } from "@cosmos/hygraph-schema";

import { EdsIcon } from "@components/elements";
import { css } from "@panda/css";

import { CosmosLink, EdsIconType, IconSize } from "..";
import { styled } from "@panda/jsx";

const TextLinkGeminiStyles = css({
	color: "eds.text.link.secondary.default",
	transition: `color token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)`,
	display: "flex",
	maxW: "100%",
	alignItems: "center",
	_hover: {
		color: "eds.text.secondary",
	},
	"& span": {
		whiteSpace: "nowrap",
		display: "inline",
		textOverflow: "ellipsis",
		flexShrink: "1",
		minW: "0",
		overflow: "hidden",
	},
	"& svg": {
		display: "inline",
		flexShrink: "0",
		"&:first-child": {
			marginInlineEnd: "eds.dimension.8",
		},
		"&:last-child": {
			marginInlineStart: "eds.dimension.8",
		},
	},
});

export const TextLinkGemini = ({
	href = "",
	label,
	edsIcon,
	endIcon = CosmosEnumLinkIcons.ChevronRight,
	iconSize = "sm",
}: GeminiLinkFragment & { iconSize?: IconSize }): React.JSX.Element | null => {
	if (!label || !href) return null;
	return (
		<CosmosLink
			href={href}
			className={TextLinkGeminiStyles}
			analytics={{
				eventCategory: "hyperlink",
				eventLabel: label || "",
				eventValue: {
					component: "TextLinkAndChevron",
					edsIcon,
					href,
				},
			}}
		>
			{edsIcon ? <EdsIcon size={iconSize} icon={edsIcon} /> : null}
			<styled.span>{label}</styled.span>
			{endIcon ? <EdsIcon size={iconSize} icon={endIcon as EdsIconType} /> : null}
		</CosmosLink>
	);
};
